import React, { Component } from "react";
import { connect } from "react-redux";
import { openSwAction } from "../../redux/ui/actions";
import { addDsAction, changeDsAction, changeNameAction, addGeoAction, delGeoAction, changeGeoAction, changeSelRowAction, isDelAction, resetGeoAction } from "../../redux/geo/actions";
import { finBoringLoadAction, changeAllDsAction, changeRegNumAction, changeNewDsAction, changeCrossValidAction } from "../../redux/boring/actions";
import { changeSwModeAction, changeEditerModeAction, changeInPredictAction, finLrnAction } from "../../redux/app/actions";
import { delAllDsAction as delAllDsPosPlAction } from "../../redux/pl/actions";
import { delAllDsAction as delAllDsPosCsAction } from "../../redux/csLine/actions";
import { delAllDsAction as delAllDsRsltPlAction } from "../../redux/rsltPl/actions";
import { delAllDsAction as delAllDsRsltCsAction, changeCsLineAction } from "../../redux/csDsp/actions";
import Sw from "../common/Sw";
import List from "./List";
import pako from "pako";

const mapStateToProps = (state) => {
    return {
        regMode: state.appReducer.regMode,
        ds: state.geoReducer.dataset,
        selRow: state.geoReducer.selRow,
        isDel: state.geoReducer.isDel,
        name: state.geoReducer.name,
        geo: state.geoReducer.geo,
        finLrn: state.appReducer.finLrn,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);
        this.ds = null;
        this.dsID = Object.keys(this.props.ds).length + 1;
        this.changeName = this.changeName.bind(this);
        this.addGeo = this.addGeo.bind(this);
        this.delGeo = this.delGeo.bind(this);
        this.changeRow = this.changeRow.bind(this);
        this.doOK = this.doOK.bind(this);
        this.closeSw = this.closeSw.bind(this);
        this.doGrouping = this.doGrouping.bind(this);
        this.reClassBoring = this.reClassBoring.bind(this);
        this.registGroup = this.registGroup.bind(this);
        this.waiting = this.waiting.bind(this);
        this.idErrorChk = this.idErrorChk.bind(this);
        this.tbRef = React.createRef();
        this.grouping = false;
        this.init = this.init.bind(this);

        if (this.props.regMode === 1) {
            //編集モードの場合
            this.ds = this.props.ds[this.props.selRow];
            this.dsID = this.ds.ID;
            this.props.dispatch(changeNameAction(this.ds.name));
            this.props.dispatch(changeGeoAction(this.ds.geo));
        }

        this.props.dispatch(changeSelRowAction(null));
    }

    componentDidUpdate(prevProps) {
        /*
         * 削除時地質IDを修正
         * @since hara 2020-10-15
         */
        if (prevProps.geo !== this.props.geo && this.props.isDel) {
            /*
             * 地質ID修正
             */
            const geo = [...this.props.geo];
            geo.forEach((el, index) => {
                el.ID = index + 1;
            });
            this.props.dispatch(changeGeoAction(geo));

            /*
             * 選択行移動
             */
            const trs = this.tbRef.childNodes;
            const rowNum = trs.length;
            const selRow = this.props.selRow;
            let newSelRow = null;

            if (selRow === rowNum) {
                //最終行削除の場合
                if (selRow !== 0) {
                    //複数行の場合前の行を選択
                    trs[rowNum - 1].click();
                    newSelRow = rowNum - 1;
                }
                this.props.dispatch(changeSelRowAction(newSelRow));
            }

            this.props.dispatch(isDelAction(false));
        }

        /*
         * 登録OK
         * @since hara 2020-10-15
         */
        if (prevProps.ds !== this.props.ds) {
            this.closeSw();
        }
    }

    /*
     * 名称入力変更
     * @param {Event} e イベント情報
     * @since hara 2020-09-09
     */
    changeName(e) {
        this.props.dispatch(changeNameAction(e.target.value));
    }

    /*
     * 地質データ取得
     */
    addGeo() {
        this.props.dispatch(addGeoAction(Object.keys(this.props.geo).length + 1));
    }

    /*
     * 地質追加
     * @since hara 2020-10-15
     */
    addGeo() {
        this.props.dispatch(addGeoAction(Object.keys(this.props.geo).length + 1));
    }

    /*
     * 地質削除
     * @since hara 2020-10-15
     */
    delGeo() {
        this.props.dispatch(delGeoAction(this.props.selRow));
        this.props.dispatch(isDelAction(true));
    }

    /*
     * フィールド変更
     * @param {Number} index フィールドの行インデックス
     * @param {String} key フィールドの列インデックス
     * @param {Event} e イベント情報
     * @since hara 2020-10-15
     */
    changeField(index, key, e) {
        const geo = [...this.props.geo];
        let value;
        if (key == "ID") {
            value = e.target.value;
            // 文字列を整数に変換でき、かつ整数であるかを確認
            if (!isNaN(value) && Number.isInteger(Number(value)) && value < 14 && value > 0) {
                value = parseInt(e.target.value);
            } else {
                value = geo[index][key];
                alert("IDは1から13までの整数を入力してください。");
            }
        } else if (key == "screen") {
            if (geo[index][key]) {
                value = false;
            } else {
                value = true;
            }
        } else {
            value = e.target.value;
        }
        geo[index] = { ...geo[index], [key]: value };

        this.props.dispatch(changeGeoAction(geo));
    }

    /*
     * 地質IDでグルーピング
     * @since ando 2024-03-09
     */
    doGrouping() {
        let data = this.props.geo;
        let change = false;
        const groupedData = data.reduce((acc, item) => {
            const existingItem = acc.find((groupedItem) => groupedItem.ID === item.ID);

            if (existingItem) {
                // 同じIDが既に存在する場合、nameを連結し、最初の色を保持
                existingItem.name += "・" + item.name;
                existingItem.group = [...existingItem.group, ...item.group];
                change = true;
            } else {
                // 同じIDが存在しない場合、新しいオブジェクトを追加
                acc.push({ ...item });
            }

            return acc;
        }, []);
        if (change) {
            groupedData.sort((a, b) => a.ID - b.ID);
            console.log(groupedData);
            this.props.dispatch(changeGeoAction(groupedData));
            this.grouping = true;
            //this.registGroup(groupedData);
        }
    }

    waiting = (stat) => {
        this.props.dispatch(changeInPredictAction(stat));
    };

    /*
     * 地質IDでグルーピング
     * @since ando 2024-03-09
     */
    registGroup() {
        try {
            if (this.grouping) {
                this.reClassBoring();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    /*
     * ボーリング再分類実行
     * @since ando 2024-03-11
     */
    reClassBoring() {
        // サーバーに送信するデータ
        const postData = {
            geo: this.props.geo,
        };

        const origin = window.location.origin;
        const search = window.location.search;
        this.waiting(true);
        fetch(`${origin}/api/boring/${search}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                // 他に必要なヘッダーがあればここに追加
            },
            body: JSON.stringify(postData),
        })
            .then((res) => {
                const contentLength = parseInt(res.headers.get("x-content-length")); // Content-Lengthヘッダーの値を取得
                const reader = res.body.getReader(); // ReadableStreamからリーダーを作成
                // 解凍処理
                const inflater = new pako.Inflate({ to: "string" });

                return new Promise((resolve, reject) => {
                    const processResult = ({ done, value }) => {
                        if (done) {
                            // 全てのデータが解凍された後に、受信データをJSON形式に変換して解析する
                            const parsedData = JSON.parse(inflater.result); // JSON文字列を解析してJavaScriptオブジェクトに変換する
                            resolve(parsedData); // 解析されたデータを解決する
                            return;
                        }
                        // データを解凍
                        inflater.push(value, false);
                        reader.read().then(processResult); // 次のチャンクを読み込む
                    };
                    reader.read().then(processResult);
                });
            })
            .then((res) => {
                let regNum = null;
                //console.log("loadBoring:", res);
                const dsLeng = res.length;
                //console.log(dsLeng);
                res.forEach((el) => {
                    window.createBoringLay(el.data, el.color, el.ID, el.vis, dsLeng - el.zIndex);
                });
                window.createScoreContour(false);
                regNum = res.length;

                this.props.dispatch(changeAllDsAction(res));
                this.props.dispatch(changeNewDsAction(res));
                this.props.dispatch(changeRegNumAction(regNum));
                this.waiting(false);
            })
            .catch((error) => {
                alert("サーバーエラー");
                this.waiting(false);
                console.error("Fetch error:", error);
            });
    }

    /*
     * 初期化
     * @since ando 2024-03-17
     */
    init() {
        //サーバからボーリングデータを読み込む場合
        const origin = window.location.origin;
        const search = window.location.search;
        let regNum = null;
        this.waiting(true);
        fetch(`${origin}/api/boring/${search}`)
            .then((res) => {
                const contentLength = parseInt(res.headers.get("x-content-length")); // Content-Lengthヘッダーの値を取得
                const reader = res.body.getReader(); // ReadableStreamからリーダーを作成
                // 解凍処理
                const inflater = new pako.Inflate({ to: "string" });

                return new Promise((resolve, reject) => {
                    const processResult = ({ done, value }) => {
                        if (done) {
                            // 全てのデータが解凍された後に、受信データをJSON形式に変換して解析する
                            const parsedData = JSON.parse(inflater.result); // JSON文字列を解析してJavaScriptオブジェクトに変換する
                            resolve(parsedData); // 解析されたデータを解決する
                            return;
                        }
                        // データを解凍
                        inflater.push(value, false);
                        reader.read().then(processResult); // 次のチャンクを読み込む
                    };
                    reader.read().then(processResult);
                });
            })
            .then((res) => {
                //console.log("loadBoring:", res);
                const dsLeng = res.length;
                //console.log(dsLeng)
                res.forEach((el) => {
                    window.createBoringLay(el.data, el.color, el.ID, el.vis, dsLeng - el.zIndex);
                });
                regNum = res.length;

                this.props.dispatch(changeAllDsAction(res));
                this.props.dispatch(changeNewDsAction(res));
                this.props.dispatch(changeRegNumAction(regNum));
                this.props.dispatch(resetGeoAction());
                this.grouping = false;
                this.waiting(false);
            })
            .catch((error) => {
                alert("サーバーエラー");
                this.waiting(false);
                console.error("Fetch error:", error);
            });
    }

    /*
     * 初期化
     * @since ando 2024-03-17
     */
    idErrorChk() {
        let data = this.props.geo;
        const idSet = new Set();

        for (const item of data) {
            if (idSet.has(item.ID)) {
                return false; // 重複がある場合
            }
            idSet.add(item.ID);
        }
        return true;
    }

    /*
     * 登録OK
     * @since hara 2020-10-15
     */
    doOK() {
        if (this.props.finLrn || window.getCP()[0] != 0) {
            if (this.idErrorChk()) {
                let action = this.props.regMode === 0 ? addDsAction : changeDsAction;

                this.props.dispatch(
                    action({
                        ID: this.dsID,
                        name: this.props.name,
                        geo: this.props.geo,
                    }),
                );
                //もし、変更されていたら分類を再実行する。
                this.registGroup();
            } else {
                alert("地質IDが重複しています。");
            }
            /*
            let answer = window.confirm('学習領域を再設定する場合、学習結果・予測位置・予測結果の\nデータが削除されます。よろしいですか。');
            if (answer) {
                window.removeModelArea();
                window.removeModelMarker();
                window.changeCP(0, 0);
                window.setSelBoringNum(0);
                this.props.dispatch(finLrnAction(false));
                //予測位置データ削除
                window.delAllCsLine();
                this.props.dispatch(delAllDsPosPlAction());
                this.props.dispatch(delAllDsPosCsAction());
                //予測結果データ削除
                this.props.dispatch(delAllDsRsltPlAction());
                this.props.dispatch(delAllDsRsltCsAction());
                //断面予測結果IDを0にする
                this.props.dispatch(changeCsLineAction(0));
                if (this.idErrorChk()) {
                    let action = this.props.regMode === 0 ? addDsAction : changeDsAction;

                    this.props.dispatch(action(
                        {
                            'ID': this.dsID,
                            'name': this.props.name,
                            'geo': this.props.geo
                        }
                    ));
                    //もし、変更されていたら分類を再実行する。
                    this.registGroup();
                } else {
                    alert("地質IDが重複しています。")
                }

            } else {

            }
            */
        } else {
            if (this.idErrorChk()) {
                let action = this.props.regMode === 0 ? addDsAction : changeDsAction;

                this.props.dispatch(
                    action({
                        ID: this.dsID,
                        name: this.props.name,
                        geo: this.props.geo,
                    }),
                );
                //もし、変更されていたら分類を再実行する。
                this.registGroup();
            } else {
                alert("地質IDが重複しています。");
            }
        }
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-09-09
     */
    closeSw() {
        //プロパティー初期化
        this.props.dispatch(changeNameAction(""));
        this.props.dispatch(changeGeoAction([]));

        this.props.dispatch(openSwAction("geoInfo"));
    }

    /*
     * テーブル選択
     * @param {Event} e イベント情報
     * @since hara 2020-10-15
     */
    changeRow(e) {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");

        this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
    }

    render() {
        const matID = [
            { value: 1, label: 1 },
            { value: 2, label: 2 },
            { value: 3, label: 3 },
            { value: 4, label: 4 },
            { value: 5, label: 5 },
            { value: 6, label: 6 },
            { value: 7, label: 7 },
            { value: 8, label: 8 },
            { value: 9, label: 9 },
            { value: 10, label: 10 },
            { value: 11, label: 11 },
            { value: 12, label: 12 },
            { value: 13, label: 13 },
        ];
        return (
            <Sw title="地質情報" focusName="geoInfoMain">
                <div className="Unit l-row">
                    <label>ID：</label>
                    <p>{this.dsID}</p>
                    <label className="l-blank">名称：</label>
                    <input className="textM" type="text" defaultValue={this.props.name} onChange={this.changeName} />
                </div>
                <div className="l-flex l-mtS">
                    {/*
                    <button className='sBtn' onClick={this.addGeo}>追加</button>
                    <button className='sBtn l-mlS' onClick={this.delGeo}>削除</button>
                    */}

                    <button className="sBtn" onClick={this.init}>
                        初期化
                    </button>
                </div>

                <div className="GeoInfoMainTWrap l-mtS" style={{ overflowY: "scroll" }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="tsS">地質ID</th>
                                <th className="tsL">地質名称</th>
                                <th className="tsSM">地質カラー</th>
                                <th className="tsSM">スクリーン設定</th>
                            </tr>
                        </thead>
                        <tbody ref={(ref) => (this.tbRef = ref)}>
                            {this.props.geo.map((el, index) => (
                                <tr id={index} key={index} onClick={this.changeRow}>
                                    <td>
                                        <select className="selectF" value={el.ID} onChange={(e) => this.changeField(index, "ID", e)}>
                                            {matID.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <input className="textT" type="text" value={el.name} onChange={(e) => this.changeField(index, "name", e)} />
                                    </td>
                                    <td className="l-p0">
                                        <input className="colorT" type="color" value={el.color} onChange={(e) => this.changeField(index, "color", e)} />
                                    </td>
                                    <td className="scrCheck">
                                        <input type="checkbox" checked={el.screen} onChange={(e) => this.changeField(index, "screen", e)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={this.doGrouping}>
                        グルーピング
                    </button>
                    <button className="cBtn" onClick={this.doOK}>
                        OK
                    </button>

                    <button className="cBtn l-mlS" onClick={this.closeSw}>
                        キャンセル
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
